/* MXDVS product page, parts A + B, assets/mxdvs-product-ab.js (15.10.2026)
   Loaded by sections/mxdvs-product.liquid after assets/mxdvs-product.js. Styling: assets/mxdvs-product-b.css.
   Reads the same JSON block as assets/mxdvs-product.js and adds to the page it builds, again after every redraw:
   - keypoints (product metafield mxdvs.keypoints, max 3) between the title and the sizes
   - one small line under Add to cart: [country] becomes the visitor's country (hidden when everything is sold out)
   - phones: the model line under the photo breaks at " / " (one person per line)
   - the terminal path sits just above the "You may also like" title (the copy inside the product info is hidden by CSS)
   - the size buttons have no hover animation (the letter decode on hover is stopped)
   - Shipping & returns zones table: free shipping amounts (stored in EUR) in the visitor's currency
   - desktop: the right side sticks 35px from the top and slides down while the floating header is shown (15.10.2026)
   - the expanded photo view: every photo full width under each other in a window that scrolls, thumbnails beside or under it,
     pull down at the top to close on phones (part C, 15.10.2026; scrolling 17.10.2026) */
(function () {
  if (window.MxProductAB) return;
  window.MxProductAB = true;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function init(root) {
    if (root.dataset.mxAb) return;
    var js = root.querySelector('[data-mxp-json]'), view = root.querySelector('[data-mxp-view]');
    if (!js || !view) return;
    root.dataset.mxAb = '1';
    var D; try { D = JSON.parse(js.textContent); } catch (e) { return; }
    var S = D.settings || {};
    var kp = (D.keypoints || []).map(function (k) { return String(k || '').trim(); }).filter(Boolean).slice(0, 3);
    var allSold = !(D.variants || []).some(function (v) { return v.available; });
    var ship = (S.shipLine && !allSold) ? String(S.shipLine).replace(/\[country\]/g, D.country || '') : '';

    /* Size buttons: no hover decode (the page's own mouseover handler on the view never hears it) */
    view.addEventListener('mouseover', function (e) { if (e.target.closest && e.target.closest('.pp-size')) e.stopPropagation(); }, true);

    var busy = false;
    function apply() {
      busy = false;
      var info = view.querySelector('.pp-info');
      if (info) {
        var head = info.querySelector('.pp-head');
        if (kp.length && head && !info.querySelector('.pp-kp')) {
          var ul = document.createElement('ul'); ul.className = 'pp-kp';
          ul.innerHTML = kp.map(function (k) { return '<li><b aria-hidden="true">+</b>' + esc(k) + '</li>'; }).join('');
          head.parentNode.insertBefore(ul, head.nextSibling);
        }
        var atc = info.querySelector(':scope > .pp-atc');
        if (ship && atc && !info.querySelector('.pp-ship')) {
          var p = document.createElement('p'); p.className = 'pp-ship'; p.textContent = ship;
          atc.parentNode.insertBefore(p, atc.nextSibling);
        }
      }
      if (innerWidth < 990 && D.caption && D.caption.indexOf(' / ') > -1) {
        var cap = view.querySelector('.pp-gal__cap');
        if (cap && !cap.dataset.mxSplit) { cap.dataset.mxSplit = '1'; cap.innerHTML = String(D.caption).split(' / ').map(esc).join('<br>'); }
      }
      var rel = document.querySelector('.mxr .mxl-h'), tpl = root.querySelector('[data-mxp-path]');
      if (rel && tpl && !rel.parentNode.querySelector(':scope > .pp-path')) {
        var path = tpl.cloneNode(true); path.hidden = false; path.removeAttribute('data-mxp-path');
        rel.parentNode.insertBefore(path, rel);
      }
    }
    function queue() { if (!busy) { busy = true; requestAnimationFrame(apply); } }
    /* after a redraw the additions go back in before the browser paints, so nothing jumps */
    new MutationObserver(function () { apply(); }).observe(view, { childList: true, subtree: true });
    window.addEventListener('resize', queue);
    queue();

    /* Desktop (15.10.2026): the right side sticks 35px under the top of the window; while the floating header is shown
       (assets/mxdvs-scroll-reveal.js: no mxr-hide / mxr-gone on .mxh) it moves down by the header's bottom edge.
       --mxp-push is used by assets/mxdvs-product-b.css; the photos on the left are not touched. */
    var hdr = document.querySelector('.mxh');
    function setPush() {
      var px = 0;
      if (innerWidth >= 990 && hdr && getComputedStyle(hdr).display !== 'none' && !hdr.classList.contains('mxr-hide') && !hdr.classList.contains('mxr-gone')) {
        px = Math.max(0, hdr.offsetTop + hdr.offsetHeight);
        var nb = document.querySelector('.mxh-nb');
        if (nb && getComputedStyle(nb).display !== 'none' && nb.offsetHeight) px = Math.max(px, nb.offsetTop + nb.offsetHeight);
      }
      view.style.setProperty('--mxp-push', px + 'px');
    }
    if (hdr) new MutationObserver(setPush).observe(hdr, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', setPush);
    setPush();

    /* ---------- Expanded photo view (part C, 15.10.2026; scrolling version 17.10.2026, demo "MXDVS photo viewer") ----------
       Replaces the single full screen photo of assets/mxdvs-product.js with a viewer that holds every photo.
       Every photo sits full width under the previous one and the window scrolls (trackpad, mouse wheel, finger, keys).
       Desktop: thumbnails on the right; above them the X (in line with the top of the photo, centred above the
       thumbnails) and the photo number, 17.5px above and below it. The thumbnail of the photo in view is marked; a click
       on a thumbnail scrolls to that photo. Left / right arrow keys go to the previous / next photo, Esc / X / a click on
       a photo closes. Phones: opens on a tap on a photo, thumbnails stay at the bottom, a sideways swipe goes to the next
       photo, a pull down at the top of the window closes it (assets/mxdvs-sheet-drag.js, 25% or a flick, no drag bar). */
    var media = (D.media || []).filter(function (m) { return m && (m.big || m.src); });
    function viewer(start) {
      if (!media.length || document.querySelector('.mxv')) return;
      var i = Math.max(0, Math.min(media.length - 1, start || 0)), pad = function (x) { return (x < 10 ? '0' : '') + x; };
      document.querySelectorAll('.mxpz-on').forEach(function (el) { el.classList.remove('mxpz-on'); });
      document.documentElement.classList.remove('mxpz-in');
      var v = document.createElement('div'); v.className = 'mxv'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', D.title || 'Product photos');
      var ph = media.map(function (m, k) {
        var r = (m.w && m.h) ? ' style="aspect-ratio:' + m.w + ' / ' + m.h + '"' : '';
        var lazy = Math.abs(k - i) > 1 ? ' loading="lazy"' : '';
        if (m.video) return '<div class="mxv__ph" data-i="' + k + '"' + r + '><video muted loop playsinline autoplay preload="metadata" poster="' + esc(m.src) + '" src="' + esc(m.video) + '"></video></div>';
        return '<div class="mxv__ph" data-i="' + k + '"' + r + '><img src="' + esc(m.big || m.src) + '" alt="' + esc(m.alt || '') + '" decoding="async"' + lazy + '></div>';
      }).join('');
      var th = media.map(function (m, k) { return '<button type="button" class="mxv__th" data-i="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + esc(m.src) + '" alt="" loading="lazy"></button>'; }).join('');
      v.innerHTML = '<div class="mxv__main">' + ph + '</div><div class="mxv__side"><button type="button" class="mxv__x" aria-label="' + esc(S.closeLabel || 'Close') + '"><svg viewBox="4 4 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg></button><span class="mxv__count"></span><div class="mxv__thumbs">' + th + '</div></div>';
      var main = v.querySelector('.mxv__main'), count = v.querySelector('.mxv__count'), box = v.querySelector('.mxv__thumbs');
      var phs = v.querySelectorAll('.mxv__ph'), thumbs = v.querySelectorAll('.mxv__th');
      var top = function () { return parseFloat(getComputedStyle(v).paddingTop) || 0; };
      /* keeps the marked thumbnail visible inside the slider without moving the window */
      function reveal(t) {
        if (box.scrollHeight > box.clientHeight + 1) {
          if (t.offsetTop < box.scrollTop) box.scrollTop = t.offsetTop - 8.5;
          else if (t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTop = t.offsetTop + t.offsetHeight - box.clientHeight + 8.5;
        } else if (box.scrollWidth > box.clientWidth + 1) {
          if (t.offsetLeft < box.scrollLeft) box.scrollLeft = t.offsetLeft - 17.5;
          else if (t.offsetLeft + t.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollLeft = t.offsetLeft + t.offsetWidth - box.clientWidth + 17.5;
        }
      }
      function mark(k) {
        i = k;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        if (thumbs[i]) reveal(thumbs[i]);
        count.textContent = pad(i + 1) + ' / ' + pad(media.length);
      }
      /* the photo in view = the last one whose top has passed 40% of the window */
      var ticking = false;
      function sync() {
        ticking = false;
        var line = v.getBoundingClientRect().top + v.clientHeight * 0.4, k = 0;
        if (v.scrollTop + v.clientHeight >= v.scrollHeight - 2) k = phs.length - 1;
        else phs.forEach(function (p, n) { if (p.getBoundingClientRect().top <= line) k = n; });
        if (k !== i || !count.textContent) mark(k);
      }
      v.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
      function go(k, smooth) {
        k = Math.max(0, Math.min(phs.length - 1, k));
        v.scrollTo({ top: Math.max(0, phs[k].offsetTop - top()), behavior: smooth ? 'smooth' : 'auto' });
        mark(k);
      }
      var shut = function () {
        if (!v.isConnected) return;
        v.classList.remove('is-on'); document.removeEventListener('keydown', key);
        document.documentElement.classList.remove('mxp-lock');
        setTimeout(function () { v.remove(); }, 300);
      };
      var key = function (e) {
        if (e.key === 'Escape') shut();
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1, true); }
      };
      v.querySelector('.mxv__x').addEventListener('click', shut);
      box.addEventListener('click', function (e) { var t = e.target.closest('.mxv__th'); if (t) go(+t.dataset.i, true); });
      main.addEventListener('click', function () { if (innerWidth >= 990) shut(); });
      /* phones: a sideways swipe on the photos goes to the next one (up and down scrolls) */
      var sx = 0, sy = 0;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) { var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5) go(i + (dx < 0 ? 1 : -1), true); }, { passive: true });
      document.addEventListener('keydown', key);
      document.body.appendChild(v);
      document.documentElement.classList.add('mxp-lock');
      /* the window itself scrolls, so the pull to close only starts at its top */
      if (window.MxSheetDrag && innerWidth < 990) MxSheetDrag.attach(v, { close: shut, closePct: 25 });
      go(i, false);
      requestAnimationFrame(function () { v.classList.add('is-on'); });
      var x = v.querySelector('.mxv__x'); if (x) x.focus({ preventScroll: true });
    }
    /* Catch the clicks before assets/mxdvs-product.js sees them (capture on the product view) */
    view.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var desk = innerWidth >= 990;
      var zb = e.target.closest('[data-act="zoom"]');
      var ds = desk ? e.target.closest('.pp-stack .pp-slide') : null;
      var tr = !desk ? e.target.closest('.pp-track') : null;
      if (!zb && !ds && !tr) return;
      e.preventDefault(); e.stopPropagation();
      var idx = 0;
      if (ds) idx = Array.prototype.indexOf.call(ds.parentNode.children, ds);
      else { var t = view.querySelector('.pp-track'); if (t && t.clientWidth) idx = Math.round(t.scrollLeft / t.clientWidth); }
      viewer(idx);
    }, true);

    /* Zones table: EUR amounts in the visitor's currency, whole amounts, two decimals */
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    root.querySelectorAll('[data-eur]').forEach(function (el) {
      var v = parseFloat(el.dataset.eur); if (isNaN(v)) return;
      try { el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: D.currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.round(v * rate)); } catch (e) {}
    });
  }

  function boot() { document.querySelectorAll('[data-mxp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
